import { createFeature, createReducer, on } from "@ngrx/store";
import { UserActions } from "../../actions/user/user.actions";
import { AuthActions } from "@store/actions/auth/auth.actions";
import { IdleActions } from "@store/actions/idle/idle.actions";
import { User } from "@models/user.model";

export const userFeatureKey = "user";

export interface State {
  displayName: string;
  email: string;
  b2cID: string;
  roles: string[];
  orgId: number;
  loggedInUser: User | null;
}

export const initialState: State = {
  displayName: "",
  email: "",
  b2cID: "",
  roles: [],
  orgId: 0,
  loggedInUser: null,
};

export const reducer = createReducer(
  initialState,
  on(AuthActions.setActiveAccountSuccess, (state, action) => ({
    ...state,
    displayName: action.account.name,
    email: action.account.username,
    b2cID: action.account.localAccountId,
    roles: [],
  })),
  on(UserActions.getUserOnLoginSuccess, (state, action) => {
    return {
      ...state,
      loggedInUser: action.user,
      roles: [action.user.roleId ?? ""],
    };
  }),
  on(UserActions.clearActiveUser, (state, action) => initialState),
  on(IdleActions.timedOut, (state, action) => initialState),
  on(UserActions.setUserOrganizationId, (state, action) => {
    return {
      ...state,
      orgId: action.id,
    };
  })
);

export const userFeature = createFeature({
  name: userFeatureKey,
  reducer,
});
